import React from 'react';
import { FILTER_TYPES } from '../../shared/enums';
import Filter from './Filter';
import NotFound from './NotFound';
import { fetchRegionalPrices } from "../features/regionalPrices/regionalPricesSlice";

const FilterWrapper = props => {
  const {
    match: {
      params: { type },
    },
  } = props;

  const Wrapper = Object.values(FILTER_TYPES).includes(type) ? Filter.component : NotFound.component;

  return (
    <Wrapper {...props} />
  );
};

const loadData = store => {
  const { localization: { data }} = store.getState();
  const actions = [
    fetchRegionalPrices(data),
  ];
  return Promise.all(actions.map(action => store.dispatch(action)));
};

export default
{
  component: FilterWrapper, loadData,
};
